export const SET_SHARE_TYPE = 'search/SET_SHARE_TYPE'
export const SET_PARENTS = 'search/SET_PARENTS'
export const SET_TIPPERS = 'search/SET_TIPPERS'
export const SET_LEAGUE = 'search/SET_LEAGUE'